import { MagritteNotificationName, NotificationName } from 'utils/constants/notification';

export enum CreateCampaignValidatorStep {
    First = 'campaign_create_first_step',
    Second = 'campaign_create_second_step',
    Third = 'campaign_create_third_step',
}

export enum EditCampaignValidatorStep {
    First = 'campaign_edit_first_step',
    Second = 'campaign_edit_second_step',
}

export enum CampaignDeviceType {
    Any = 'ANY',
    Mobile = 'MOBILE',
    Desktop = 'DESKTOP',
}

export enum CampaignGender {
    Any = 'ANY',
    Male = 'MALE',
    Female = 'FEMALE',
}

export const CAMPAIGN_ROOT_REGION_ID = '113';
export const CAMPAIGN_SELECTED_ROOT_REGION = [CAMPAIGN_ROOT_REGION_ID];
export const CAMPAIGN_MOSCOW_AREA_REGION = '2019';
export const CAMPAIGN_MOSCOW_REGION = '1';
export const CAMPAIGN_SAINT_PETERSBURG_REGION = '2';
export const CAMPAIGN_SAINT_PETERSBURG_AREA_REGION = '145';

export const FIRST_PLACE_REGIONS = [
    CAMPAIGN_MOSCOW_REGION,
    CAMPAIGN_MOSCOW_AREA_REGION,
    CAMPAIGN_SAINT_PETERSBURG_REGION,
    CAMPAIGN_SAINT_PETERSBURG_AREA_REGION,
];

export const CAMPAIGN_MIN_AGE = 16;
export const CAMPAIGN_MAX_AGE = 65;

export const CAMPAIGN_GENDERS = [CampaignGender.Any, CampaignGender.Male, CampaignGender.Female];

export enum CampaignSalary {
    To30000 = '30000',
    From30000To50000 = '50000',
    From50000To75000 = '75000',
    From75000To100000 = '100000',
    From100000To150000 = '150000',
    From150000 = 'many',
}

export const CAMPAIGN_SALARIES = [
    CampaignSalary.To30000,
    CampaignSalary.From30000To50000,
    CampaignSalary.From50000To75000,
    CampaignSalary.From75000To100000,
    CampaignSalary.From100000To150000,
    CampaignSalary.From150000,
];

export enum CampaignLanguage {
    English = 'ENGLISH',
    French = 'FRENCH',
    German = 'GERMAN',
}

export const CAMPAIGN_LANGUAGES = [CampaignLanguage.English, CampaignLanguage.German, CampaignLanguage.French];

export enum CampaignSubSource {
    Social = 'SOCIAL',
    HH = 'HH',
    // exp_PORTFOLIO-53635_start
    HHTopSearch = 'HH_TOP_SEARCH',
    HHBanners = 'HH_BANNERS',
    // exp_PORTFOLIO-53635_end
    VK = 'VK',
    Adwords = 'ADWORDS',
    Direct = 'DIRECT',
    YandexSearch = 'YANDEX_SEARCH',
    YandexNetwork = 'YANDEX_NETWORK',
    Facebook = 'FACEBOOK',
    Instagram = 'INSTAGRAM',
    VKAdsVK = 'VK_ADS_VK',
    VKAdsOK = 'VK_ADS_OK',
    VKAdsNetwork = 'VK_ADS_NETWORK',
    VKAdsProject = 'VK_ADS_PROJECT',
}

export enum CampaignSource {
    Social = 'SOCIAL',
    HH = 'HH',
    VK = 'VK',
    Adwords = 'ADWORDS',
    Direct = 'DIRECT',
    Yandex = 'YANDEX_DIRECT',
    Facebook = 'FACEBOOK',
    Instagram = 'INSTAGRAM',
    VKAds = 'VK_ADS',
}

export const VK_ADS_SUB_SOURCES = [
    CampaignSubSource.VKAdsVK,
    CampaignSubSource.VKAdsOK,
    CampaignSubSource.VKAdsNetwork,
    CampaignSubSource.VKAdsProject,
];

// exp_PORTFOLIO-53635_start
export const HH_SUB_SOURCES = [CampaignSubSource.HH, CampaignSubSource.HHTopSearch, CampaignSubSource.HHBanners];
export const HH_SPLIT_SUB_SOURCES = [CampaignSubSource.HHTopSearch, CampaignSubSource.HHBanners];
// exp_PORTFOLIO-53635_end

export const YANDEX_SUB_SOURCES = [CampaignSubSource.YandexNetwork, CampaignSubSource.YandexSearch];

export const SUBSOURCE_TO_SOURCE_MAPPING = {
    [CampaignSubSource.Social]: CampaignSource.Social,
    [CampaignSubSource.HH]: CampaignSource.HH,
    // exp_PORTFOLIO-53635_start
    [CampaignSubSource.HHTopSearch]: CampaignSource.HH,
    [CampaignSubSource.HHBanners]: CampaignSource.HH,
    // exp_PORTFOLIO-53635_end
    [CampaignSubSource.VK]: CampaignSource.VK,
    [CampaignSubSource.Adwords]: CampaignSource.Adwords,
    [CampaignSubSource.Direct]: CampaignSource.Direct,
    [CampaignSubSource.YandexSearch]: CampaignSource.Yandex,
    [CampaignSubSource.YandexNetwork]: CampaignSource.Yandex,
    [CampaignSubSource.Facebook]: CampaignSource.Facebook,
    [CampaignSubSource.Instagram]: CampaignSource.Instagram,
    [CampaignSubSource.VKAdsVK]: CampaignSource.VKAds,
    [CampaignSubSource.VKAdsOK]: CampaignSource.VKAds,
    [CampaignSubSource.VKAdsNetwork]: CampaignSource.VKAds,
    [CampaignSubSource.VKAdsProject]: CampaignSource.VKAds,
};

export enum CampaignSubSourceDisableReason {
    LowBalance = 'LOW_BALANCE',
    LowImgRes = 'LOW_IMG_RES',
    LowImgResAndLowBalance = 'LOW_IMG_RES_AND_LOW_BALANCE',
}

export const SOURCE_FOR_STATS = [
    CampaignSubSource.HH,
    CampaignSource.VKAds,
    CampaignSubSource.YandexSearch,
    CampaignSubSource.YandexNetwork,
];

export const CAMPAIGN_SOURCES_WITH_UNKNOWN_AGE = [CampaignSubSource.Direct, CampaignSubSource.Adwords];

export const CAMPAIGN_SOCIAL_SOURCES = [
    CampaignSubSource.Social,
    CampaignSubSource.Facebook,
    CampaignSubSource.VK,
    CampaignSubSource.Instagram,
];

export const DISABLE_OFF_SOURCES = [CampaignSubSource.Adwords, CampaignSubSource.Facebook, CampaignSubSource.Instagram];

export enum CampaignSteps {
    First = '0',
    Second = '1',
    Third = '2',
}

export const isFirstStep = (step: number): boolean => String(step) === CampaignSteps.First;
export const isSecondStep = (step: number): boolean => String(step) === CampaignSteps.Second;
export const isThirdStep = (step: number): boolean => String(step) === CampaignSteps.Third;

export const CAMPAIGN_AVAILABLE_STEPS = [CampaignSteps.First, CampaignSteps.Second];

export const CAMPAIGN_LOW_BALANCE = 2000;

export enum CampaignType {
    Advertising = 'ADVERTISING',
    Information = 'INFORMATION',
}

export enum CampaignProcess {
    Create,
    Copy,
    Edit,
}

export const CAMPAIGN_ID_URL_FIELD_NAME = 'campaignId';
export const CAMPAIGNS_CURRENT_TAB_URL_FIELD_NAME = 'campaignsCurrentTab';

export enum CampaignProductType {
    Cpc = 'CLICKME_CPC',
    SearchAuction = 'CLICKME_SEARCH_AUCTION',
    // exp_PORTFOLIO-58018_next_line
    Vr = 'CLICKME_VR',
    // exp_PORTFOLIO-61587_next_line
    VacancyOfTheDay = 'CLICKME_VACANCY_OF_THE_DAY',
}

export const STEPS_COUNT_BY_PROCESS = {
    [CampaignProcess.Create]: 3,
    [CampaignProcess.Edit]: 2,
    [CampaignProcess.Copy]: 3,
};

export const CAMPAIGN_CREATING_STATUSES = [CampaignProcess.Create, CampaignProcess.Copy];

export const DUMMY_VACANCY = 99999999;

export const RECOMMENDED_TOTAL_BUDGET = 20000;
export const TOTAL_BUDGET_MIN = 0;
export const TOTAL_BUDGET_STEP_RUB = 1000;
export const DAILY_BUDGET_MIN = 0;
export const DAILY_BUDGET_STEP_RUB = 1000;

export enum VacancyError {
    VacancyNotFoundError = 'VACANCY_NOT_FOUND_ERROR',
    IllegalVacancyStatusError = 'ILLEGAL_VACANCY_STATUS_ERROR',
    InvalidUrlError = 'INVALID_URL_ERROR',
}

export const ERROR_VACANCY_BANNER_LINK_NOTIFICATION_MAP = {
    [VacancyError.VacancyNotFoundError]: NotificationName.ErrorVacancyInBannerLink,
    [VacancyError.IllegalVacancyStatusError]: NotificationName.ErrorVacancyInBannerLink,
    [VacancyError.InvalidUrlError]: NotificationName.ErrorUrlInBannerLink,
};

export const ERROR_VACANCY_BANNER_LINK_MAGRITTE_NOTIFICATION_MAP = {
    [VacancyError.VacancyNotFoundError]: MagritteNotificationName.ErrorVacancyInBannerLink,
    [VacancyError.IllegalVacancyStatusError]: MagritteNotificationName.ErrorVacancyInBannerLink,
    [VacancyError.InvalidUrlError]: MagritteNotificationName.ErrorUrlInBannerLink,
};

export const PAGE_SIZE = 50;
